// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4792":"52b02a5f0bf53a2770e0","5724":"52b02a5f0bf53a2770e0"}[chunkId] + ".chunk.css";
};